import PreciateEventType from './preciate-event-type';

export default class PreciateEventHelper {
  public constructor(
    public userId: string,
    public identity: string,
    public type: PreciateEventType,
  ) {}
}
